<template>
  <div class="i-layout-menu-head-title">
    <span
      class="i-layout-menu-head-title-icon"
      v-if="(item.icon || item.custom || item.img) && !hideIcon"
    >
      <Icon :type="item.icon" v-if="item.icon" />
      <Icon :custom="item.custom" v-else-if="item.custom" />
      <img :src="item.img" v-else-if="item.img" />
    </span>
    <Badge
      v-if="item.name == '公告管理' && unNumber.NotifysUndefind > 0"
      :count="unNumber.NotifysUndefind"
      overflow-count="999"
      class-name="demo-badge-alone"
    >
      <span class="i-layout-menu-head-title-text">{{ item.name }}</span>
    </Badge>
    <Badge
      v-else-if="item.name == '公文管理' && unNumber.receviceNureadNumber > 0"
      :count="unNumber.receviceNureadNumber"
      overflow-count="999"
      class-name="demo-badge-alone"
    >
      <span class="i-layout-menu-head-title-text">{{ item.name }}</span>
    </Badge>
    <Badge
      v-else-if="item.name == '审批管理' && unNumber.SPunread > 0"
      :count="unNumber.SPunread"
      overflow-count="999"
      class-name="demo-badge-alone"
    >
      <span class="i-layout-menu-head-title-text">{{ item.name }}</span>
    </Badge>
    <span v-else class="i-layout-menu-head-title-text">{{ item.name }}</span>
  </div>
</template>
<script>
/**
 * 该组件除了 Menu，也被 Breadcrumb 使用过
 * */
import tTitle from "../mixins/translate-title";

export default {
  name: "iMenuHeadTitle",
  mixins: [tTitle],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    // unNumber:{
    //     type: Object,
    //   default: false,
    // }
  },
  data(){
    return{
        unNumber:{}
    }
  },
  mounted() {
    let unRead = this.$store.state.unRead;
    this.unNumber = unRead;
  },
  methods: {
    // 公告
  },
};
</script>

<style>
.demo-badge-alone {
  width: 12px;
  height: 12px;
  margin-top: 20px;
  background: #eee;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  left: 55px;
  padding: 0px !important;
}
</style>
